module.exports = __webpack_public_path__ + "media/images/onboarding-3-e536e9b6ec79c100ff62acf675f66997.webp";